import { AlertMessage } from "features/common/components/AlertMessage";
import { ConfirmModal } from "features/common/components/ConfirmModal";
import { useExportClientModal } from "./useExportClientsModal";
import { Box } from "@mui/material";

export interface ExportClientsModalProps {
  idList: number[];
  taskNr: string;
  onClose: () => void;
  isOpen: boolean;
}

export const ExportClientsModal = ({
  idList,
  taskNr,
  onClose,
  isOpen,
}: ExportClientsModalProps) => {
  const {
    canExport,
    isExecutingExport,
    exportError,
    handleExport,
    isExportCompleted,
    handleClose,
    reportId,
  } = useExportClientModal({
    idList,
    taskNr,
    onClose,
  });

  return (
    <ConfirmModal
      title="Export clients"
      open={isOpen}
      onClose={handleClose}
      isLoading={isExecutingExport}
      error={exportError}
      disableConfirmButton={!canExport}
      onConfirm={handleExport}
      secondaryAction={idList.length > 0 && taskNr ? null : <></>}
      disableBackdropClick
      hideConfirmButton={isExportCompleted}
      children={
        idList.length > 0 && taskNr && !isExportCompleted ? (
          "Do you want to EXPORT the selected rows ?"
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {idList.length === 0 && (
              <AlertMessage
                show
                isPermanent
                message={"No relevant selected!\nSelect one or more relevant."}
                severity="error"
              />
            )}
            {!taskNr && (
              <AlertMessage
                show
                isPermanent
                message={
                  "The task must be entered!\nThis you can find in the order email (TASK-xxx)."
                }
                severity="error"
              />
            )}
            {isExportCompleted && <>{`File ${reportId} created`}</>}
          </Box>
        )
      }
    />
  );
};
